import { Image } from '@/components/Image'
import { decodeURL } from '@/core/utils/dom/decodeURL'
import type { BuilderImage } from '@/models/BuilderImage'

import {
  StepContainer,
  StepContent,
  StepDownloadReference,
  StepDownloadReferences,
  StepNumber,
  StepText,
} from './styles'

interface DownloadReference {
  image?: BuilderImage
  url: string
}

export interface StepProps {
  number: number
  text: string
  downloadReferences: DownloadReference[] | undefined
}

const Step = ({ number, text, downloadReferences }: StepProps) => {
  const isThereAnyDownloadReference = downloadReferences && downloadReferences.length > 0

  return (
    <StepContainer tag="li">
      <StepContent>
        <StepNumber aria-hidden={true}>{number}</StepNumber>
        <StepText tag="div" html={text} />
      </StepContent>
      {isThereAnyDownloadReference && (
        <StepDownloadReferences>
          {downloadReferences.map(
            (reference, index) =>
              reference && (
                <StepDownloadReference
                  {...(reference.image && { 'aria-label': reference.image.alt })}
                  key={`step-dw-ref-${index}`}
                  href={decodeURL(reference.url)}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {reference.image && (
                    <Image source={reference.image.url} alt="" width={136} height={48} />
                  )}
                </StepDownloadReference>
              ),
          )}
        </StepDownloadReferences>
      )}
    </StepContainer>
  )
}

export default Step
